import { downloadFileFromUrl } from 'download-file-from-url';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list/lib/flights';
import { isSmimeAttachmentType } from 'owa-attachment-model-store';
import refreshDownloadUrl from 'owa-attachment-model-store/lib/actions/refreshDownloadUrl';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import type AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { lazyDownloadSmimeAttachment } from 'owa-smime';

/**
 * Utility which handles the download of an attachment
 * For S/MIME attachments we pass on the control to owa-smime
 * @param attachmentId
 * @param isCloudy
 * @param container
 */
export default async function downloadAttachment(
    attachmentId: AttachmentId,
    isCloudy: boolean,
    container?: HTMLElement
) {
    const attachmentModel = getAttachment(attachmentId);
    if (!attachmentModel) {
        return;
    }

    if (isMonarchMultipleAccountsEnabled()) {
        refreshDownloadUrl(
            attachmentModel.id,
            true /* isReadOnly */,
            true /* addIsDownloadQueryParam */
        );
    }

    if (isSmimeAttachmentType(attachmentModel.model)) {
        (await lazyDownloadSmimeAttachment.import())(attachmentModel.model);
    } else {
        const downloadUrl = attachmentModel.download.url;
        downloadUrl && downloadFileFromUrl(downloadUrl, isCloudy, container);
    }
}
